export const LeadMarketing2Model = {
  datefrom: "",
  dateto: "",
  datefrom1: "",
  dateto1: "",
  leadStage: "",
  userId: "",
  branchId: "",
  yearId: "",
  campaignId: "",
};
